<template>
<div v-on:dblclick.stop.prevent="changeElementShow">
	<div class="form-group"  v-if="label === undefined || label === true">
		<label-input :id="id" :explanation="explanation" :write="true" v-on:open-modal="changeElementShow" :scope="scope" v-if="label === undefined || label === true" />
			<static-input :id="id" v-if="datatype === 'boolean'">
				<i :class="iconBoolean"></i>
			</static-input>
			<static-input :id="id" v-else-if="datatype === 'password'">
				<i :class="iconPassword"></i>
			</static-input>
<!-- 			<static-input :id="id" v-else-if="datatype === 'bigtext'"> -->
<!-- 				<i :class="iconText"></i>  -->
<!-- 			</static-input> -->
			<static-input :id="id" v-else-if="$te(scopeSelect+'.'+data)" :openLink="openLink" :openLinkGet="openLinkGet" :checkLinkFirst="checkLinkFirst">{{$t(scopeSelect+'.'+data)}}</static-input>
			<static-input :id="id" :openLink="openLink" :openLinkGet="openLinkGet" :checkLinkFirst="checkLinkFirst" v-else>{{data}}</static-input>
	</div>

	<static-output v-else :scope="scopeSelect" :value="data"/>

	<modal-input @change-element="changeElement"
		@close-modal="showModal = false" :get="get" :scope="scope"
		:modalid="'modal-'+id" :value="data" :datatype="datatype"
		:id="id" v-if="showModal" :scopeSelect="scopeSelect" :dataSelect="dataSelect" :maxChars="maxChars"></modal-input>
</div>
</template>

<script>
import StaticInput from "@/components/input/StaticInput.vue";
import LabelInput from "@/components/input/LabelInput.vue";
import ModalInput from "@/components/input/ModalInput.vue";

export default {
  name: "LabelStaticModal",
  components: {
    StaticInput,
    LabelInput,
    ModalInput
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    iconBoolean: function() {
      return {
    	"glyphicon glyphicon-ok": this.data === true,
   		"glyphicon glyphicon-remove": this.data !== true
      };
    },
  iconPassword: function() {
      return {
      	"fa fa-lock": this.data === true,
   		"fa fa-unlock-alt": this.data !== true
      };
    },
  iconText: function() {
	  return {
		  "fa fa-file-text-o": this.data == null,
		  "fa fa-file-text": this.data != null,
	  };
    }
  },
  props: ["id", "data", "dataSelect", "scope", "datatype", "get", "set", "explanation", "scopeSelect", "openLinkGet", "openLink", "label", "checkLinkFirst", "download", "maxChars"],
  methods: {

    changeElementShow() {
      this.showModal = true;
      this.$nextTick(() => {
        $("#modal-" + this.id).modal("show");
      });
    },



    changeElement() {
      var modal = "#modal-" + this.id;
      $(modal + " .button_tiefox_dark")
        .addClass("disabled")
        .prop("disabled", true);
      $(modal + " .wait").removeClass("hidden");

      var value;
      if ($(modal + " .inputElement").is(":checkbox")) {
        value = $(modal + " .inputElement").prop("checked");
      } else {
        value = $(modal + " .inputElement").val();
      }
      var text = value;

      if ($(modal + " .inputElement").is("select")) {
    	value = $(modal + " option:selected").val();
        text = $(modal + " option:selected").text();
      } else if($(modal + " .inputElement").is(":password")) {
    	  if(value !== $("#password2").val()) {
    		  $(modal + " .button_tiefox_dark")
              .removeClass("disabled")
              .prop("disabled", false);
            $(modal + " .wait").addClass("hidden");
            $(modal + " .error")
            .html("<b>" + this.$t('misc.errors.wrongRepeat', {attribute:this.$t(this.scope+'.values.'+this.id)}) + "</b>")
            .removeClass("hidden");
            return;
    	  }

    	  text = true;
      }

      axios
        .post(this.set, {
          key: this.id,
          value: value
        })
        .then(response => {
          $(modal + " .button_tiefox_dark")
            .removeClass("disabled")
            .prop("disabled", false);
          $(modal + " .wait").addClass("hidden");
          if (response.data.status === true) {

        	if(response.data.hasOwnProperty('data')) {
        		this.$emit('value-change', this.id, text, value, response.data.data);
        	} else {
        		this.$emit('value-change', this.id, text, value);
        	}

//         	if(this.event == null) {
//                this.$eventBus.$emit("update-value", this.id, text, this.eventParam1, this.eventParam2);
//         	} else {
//         	   this.$eventBus.$emit(this.event, this.id, text, this.eventParam1, this.eventParam2);
//         	}

            $(modal).modal("hide");
            this.showModal = false;
          } else {
            $(modal + " .error")
              .html("<b>"+ this.$t('misc.errors.' + response.data.reason, {attribute:this.$t(this.scope+'.values.'+this.id)}) +"</b>")
              .removeClass("hidden");
          }
        }).catch(error => {
        	 $(modal + " .wait").addClass("hidden");
        	  if (error.response) {
        		$(modal + " .error").html("<b>"+this.$t('misc.errorServerResponse', {status:error.response.status})+"</b>").removeClass("hidden");
	          } else if (error.request) {
	        	$(modal + " .error").html("<b>"+this.$t('misc.errorNoServerResponse', {status:error.response.status})+"</b>").removeClass("hidden");
	          }
		 });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/LabelStaticModalInput.vue